module.exports = __webpack_public_path__ + "static/globe-07e8855550537596e420f7d329f19cf3.png";